export const MIN_PASSWORD_LENGTH = 15;

export const getPasswordPolicyError = (password, { username = '', email = '' } = {}) => {
  const value = typeof password === 'string' ? password : '';
  if (value.length < MIN_PASSWORD_LENGTH) {
    return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (value.length > 128) {
    return 'Use no more than 128 characters.';
  }

  const normalized = value.trim().toLowerCase();
  const identityTokens = [username, String(email).split('@')[0]]
    .map((item) => String(item || '').trim().toLowerCase())
    .filter((item) => item.length >= 4);
  if (identityTokens.some((token) => normalized.includes(token))) {
    return 'Do not include the username or email name.';
  }

  const categories = [
    /[a-z]/.test(value),
    /[A-Z]/.test(value),
    /\d/.test(value),
    /[^A-Za-z0-9\s]/.test(value)
  ].filter(Boolean).length;
  if (categories < 3) {
    return 'Use at least three types: lowercase, uppercase, number, or symbol.';
  }
  return '';
};

export const PASSWORD_POLICY_HELPER = '15+ characters and at least three types: lowercase, uppercase, number, or symbol.';
